import {
  SelectGroup,
  SelectItem,
  SelectLabel,
} from "../../../shadcn/ui/select";
import {
  formatTime12,
  toTimeValue,
  type GroupedTimeSlots,
} from "./scheduler-utils";

const TIME_OF_DAY_GROUPS = [
  { label: "Morning", key: "morning" as const },
  { label: "Afternoon", key: "afternoon" as const },
  { label: "Evening", key: "evening" as const },
];

export function TimeSlotSelectContent({
  grouped,
}: {
  grouped: GroupedTimeSlots;
}) {
  return (
    <>
      {TIME_OF_DAY_GROUPS.map(
        ({ label, key }) =>
          grouped[key].length > 0 && (
            <SelectGroup key={label}>
              <SelectLabel className="text-[11px] font-semibold text-zinc-400">
                {label}
              </SelectLabel>
              {grouped[key].map((s) => {
                const val = toTimeValue(s.h, s.m);
                return (
                  <SelectItem key={val} value={val}>
                    {formatTime12(s.h, s.m)}
                  </SelectItem>
                );
              })}
            </SelectGroup>
          )
      )}
    </>
  );
}
